<template>
  <div />
</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        name: "Main",
        data() {
            return {}
        },
        computed: {

        },
        mounted() {

        },


    }
</script>

<style scoped>

</style>
